import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import BetslipAlertsModule from '../../alerts/alerts.module';
import { AlertType } from '../../alerts/models';

@Component({
    selector: 'bs-bet-builder-popup',
    templateUrl: 'bet-builder-popup.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./bet-builder-popup.component.scss'],
    imports: [BetslipAlertsModule],
    host: { class: 'betslip-vars-scope' },
})
export class BetBuilderPopupComponent {
    notificationMessage = input.required<string>();

    alertType = AlertType.Information;
}
